module.exports = require('./helpers/bundle-url').getBundleURL('5wSQ1') + "logo.c51670a8.svg";